import { ChartType } from './enum/chart-type';

export class ComponentCharts {
    chartTypes: ChartType[];
    selectedChartType: ChartType;
    dashboardItemRef: string;
    calcRef: number;
}
